import React, { useState } from 'react';
import { Button, MasterDetailForm, FormSelect, FormTextArea, FormSubmitButton, Row, FormNumber } from '@digital/ui';
import { Tooltip, Modal } from 'antd';
import { UploadMultipleTableTmp, Visibility } from '@app/components';
import { ISasPropostaOrdemCompra, updateHomologacao } from '@app/api/sas/sasProposta';
import { useRecoilState } from 'recoil';
import { modalAcoesIdState, reloadState, reloadVendorListState } from '../atoms';
import * as Yup from 'yup';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { getArquivosDocumentoOrdemCompraByOc } from '@app/api/sas/sasDocumentoOrdemCompra';
import { EGuidTipoSasDocumento } from '@app/enums/EGuidTipoSasDocumento';

interface Props {
    sasPropostaId: string;
    sasProposta: ISasPropostaOrdemCompra;
}

const ModalHomologacao = (props: Props) => {
    const { sasPropostaId, sasProposta } = props;

    const [reloadVendorList, setReloadVendorList] = useRecoilState(reloadVendorListState);
    const [modalAcoesId, setModalAcoesId] = useRecoilState(modalAcoesIdState);

    const [exibirModal, setExibirModal] = useState(false);

    const handleCancel = () => {
        setExibirModal(false);
    };

    const handleSubmit = (values: any) => {
        const form = new FormData();

        form.append('sasPropostaId', sasPropostaId);
        form.append('statusResultadoHomologacao', values.statusResultadoHomologacao);
        form.append('numeroTotvs', values.numeroTotvs ? values.numeroTotvs : '');
        form.append('comentarioResultadoHomologacao', values.comentarioResultadoHomologacao ? values.comentarioResultadoHomologacao : '');
        values.anexosHomologacao.map((c: any, i: any) => {
            form.append("anexosHomologacao", c);
        });

        updateHomologacao(form)
            .then((data: any) => {
                if (data.valid) {
                    setReloadVendorList(!reloadVendorList);
                    handleCancel();
                }
                setModalAcoesId('');
            });
    };

    return (
        <>
            <Tooltip title="Homologação" >
                <Button icon='files-check_file_filled2' onClick={() => { setExibirModal(true); }} />
            </Tooltip>
            <Modal title={`Homologação`} width='780px' visible={exibirModal} onCancel={handleCancel} footer={null} >
                <Visibility visible={isObjNotEmpty(sasProposta) && exibirModal} >
                    <MasterDetailForm
                        key={`formHomologacao_${sasPropostaId}`}
                        initialValues={sasProposta}
                        actions={[
                            <Button title='fechar' type='link' onClick={() => handleCancel()} />,
                            <FormSubmitButton title='Salvar' type='primary' noIcon onClick={handleSubmit} />
                        ]}
                        validationSchema={Yup.object().shape({
                            statusResultadoHomologacao: Yup.string().required('O campo é obrigatório.'),
                            numeroTotvs: Yup.string().nullable()
                                .when('statusResultadoHomologacao', {
                                    is: (value) => (value == 'Homologado' || value == 'Homologado com Pendência'),
                                    then: Yup.string().required("O campo é obrigatório.")
                                }),
                            files: Yup.array()
                                .when('statusResultadoHomologacao', {
                                    is: (value) => (value == 'Não Homologado' || value == 'Homologado com Pendência'),
                                    then: Yup.array().min(1, 'É necessário anexar no mínimo um arquivo.')
                                }),
                            comentarioResultadoHomologacao: Yup.string()
                                .when('statusResultadoHomologacao', {
                                    is: (value) => (value == 'Não Homologado' || value == 'Homologado com Pendência'),
                                    then: Yup.string().required("O campo é obrigatório.")
                                }),
                        })}
                    >
                        <Row>
                            <FormSelect
                                label='Status'
                                name='statusResultadoHomologacaoShow'
                                value={sasProposta.statusResultadoHomologacao ? sasProposta.statusResultadoHomologacao : "Em Homologação"}
                                options={[
                                    { text: 'Em Homologação', value: 'Em Homologação' }
                                ]}
                                span={6}
                                disabled
                            />
                            <FormNumber label='Número Totvs' name='numeroTotvs' span={6} />
                        </Row>
                        <Row>
                            <FormSelect
                                label='Avaliação'
                                name='statusResultadoHomologacao'
                                options={[
                                    { text: 'Homologado', value: 'Homologado' },
                                    { text: 'Homologado com Pendência', value: 'Homologado com Pendência' },
                                    { text: 'Em Homologação', value: 'Em Homologação' },
                                    { text: 'Não Homologado', value: 'Não Homologado' },
                                ]}
                                span={6}
                            />
                        </Row>
                        <Row>
                            <FormTextArea name='comentarioResultadoHomologacao' label='Justificativa' />
                        </Row>
                        <Row>
                            <UploadMultipleTableTmp
                                name='anexosHomologacao'
                                idDoComponente={`formHomologacaoUpload_${sasPropostaId}`}
                                type='primary'
                                tablePagination={true}
                                onGetArquivos={async () => {
                                    return await getArquivosDocumentoOrdemCompraByOc({
                                        ordemCompraId: sasProposta.ordemCompraId,
                                        sasTipoDocumentoId: EGuidTipoSasDocumento.AnexoHomologacao,
                                        sasPropostaId: sasPropostaId,
                                    }).then((data) => {
                                        return data || [];
                                    });
                                }}
                            />
                        </Row>
                    </MasterDetailForm>
                </Visibility>
            </Modal>
        </>
    );
};

export default ModalHomologacao;